import * as React from "react";
import moment from "moment";
import { ToplineSection } from "./ToplineSection";
import { ToplineMetricsState } from "../../reducer";
import _ from "lodash";

interface ToplineMetricsProps {
  start_date: string;
  end_date: string;
  metric: string;
  toplineMetrics: ToplineMetricsState;
}

export class ToplineMetrics extends React.Component<ToplineMetricsProps, {}> {
  metricFormat = (number: number) => {
    if (this.props.metric == "spend")
      return typeof number == "number"
        ? number
            .toLocaleString("currency", { style: "currency", currency: "USD" })
            .split(".")[0]
        : "$0";
    else if (this.props.metric == "average_time_on_flyer")
      return typeof number == "number" ? number.toLocaleString() + "s" : "0s";
    else return typeof number == "number" ? number.toLocaleString() : "0";
  };

  capitalize = (metric: string) => {
    return _.startCase(metric.replace("_", " "));
  };

  decimalize = (value: number) => {
    let _value = value ? parseFloat(value.toFixed(2)).toLocaleString() : null;
    return _value ? `(${(value > 0 ? "+" : "") + _value}%)` : null;
  };
  render() {
    let { start_date, end_date, metric, toplineMetrics } = this.props;
    let startDate = moment(this.props.start_date, "YYYY-MM-DD", true);
    let endDate = moment(this.props.end_date, "YYYY-MM-DD", true);
    let startDateYear = moment(this.props.start_date).format("YYYY");
    let endDateYear = moment(this.props.end_date).format("YYYY");
    let toDateStartYear =
      startDateYear == endDateYear
        ? moment(this.props.start_date).subtract(1, "years").format("YYYY")
        : startDateYear;
    let toDateEndYear =
      startDateYear == endDateYear
        ? moment(this.props.start_date).subtract(1, "years").format("YYYY")
        : endDateYear;
    let yoyAggregate,
      yoyDelta,
      yoyPercentDelta = null;
    let ytdAggregate,
      ytdDelta,
      ytdPercentDelta = null;
    let mtdAggregate,
      mtdDelta,
      mtdPercentDelta = null;
    if (!toplineMetrics) {
      toplineMetrics = default_topline_metrics;
    }

    if (typeof toplineMetrics.yoy_aggregate == "number") {
      yoyAggregate = this.metricFormat(toplineMetrics.yoy_aggregate);
      yoyDelta = this.metricFormat(toplineMetrics.yoy_delta);
      yoyPercentDelta = this.decimalize(toplineMetrics.yoy_percent_delta);
    }

    if (typeof toplineMetrics.year_to_month_aggregate == "number") {
      ytdAggregate = this.metricFormat(toplineMetrics.year_to_month_aggregate);
      ytdDelta = this.metricFormat(toplineMetrics.year_to_month_delta);
      ytdPercentDelta = this.decimalize(
        toplineMetrics.year_to_month_percent_delta
      );
    }

    if (typeof toplineMetrics.month_to_date_aggregate == "number") {
      mtdAggregate = this.metricFormat(toplineMetrics.month_to_date_aggregate);
      mtdDelta = this.metricFormat(toplineMetrics.month_to_date_delta);
      mtdPercentDelta = this.decimalize(
        toplineMetrics.month_to_date_percent_delta
      );
    }

    let yoyPopoverContents = (
      <div style={{ width: 400 }}>
        Based on all publications between{" "}
        {` ${startDate.format("ll")}- ${endDate.format("ll")} `}
        compared to the same period in the previous year (
        {`${startDate.clone().subtract(1, "years").format("ll")} - ${endDate.clone().subtract(1, "years").format("ll")}`}
        )
      </div>
    );

    let ytdPopoverContents = (
      <div style={{ width: 400 }}>
        Based on all publications between Jan 1,{" "}
        {` ${endDateYear} - ${endDate.format("ll")} `}
        compared to the same period in the previous year (Jan 1,{" "}
        {toDateStartYear} - {endDate.clone().format("MMM D, ")}
        {toDateStartYear})
      </div>
    );

    let mtdPopoverContents = (
      <div style={{ width: 400 }}>
        Based on all publications between&nbsp;
        {endDate.clone().startOf("month").format("ll")} -{" "}
        {endDate.format("ll") + " "}
        compared to the same period in the previous month (
        {endDate
          .clone()
          .subtract(1, "months")
          .startOf("month")
          .format("ll")} - {endDate.clone().subtract(1, "months").format("ll")}
        ).
      </div>
    );

    return (
      <div className="topline-metrics">
        <ToplineSection
          title="YEAR OVER YEAR"
          popoverContents={yoyPopoverContents}
          aggregateValue={yoyAggregate}
          deltaValue={yoyDelta}
          percentDeltaValue={yoyPercentDelta}
        />
        <ToplineSection
          title="YEAR TO DATE"
          popoverContents={ytdPopoverContents}
          aggregateValue={ytdAggregate}
          deltaValue={ytdDelta}
          percentDeltaValue={ytdPercentDelta}
        />
        <ToplineSection
          title="MONTH TO MONTH"
          popoverContents={mtdPopoverContents}
          aggregateValue={mtdAggregate}
          deltaValue={mtdDelta}
          percentDeltaValue={mtdPercentDelta}
        />
      </div>
    );
  }
}

const default_topline_metrics: ToplineMetricsState = {
  yoy_aggregate: null,
  yoy_delta: null,
  yoy_percent_delta: null,
  year_to_month_aggregate: null,
  year_to_month_delta: null,
  year_to_month_percent_delta: null,
  month_to_date_aggregate: null,
  month_to_date_delta: null,
  month_to_date_percent_delta: null
};



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/ToplineMetrics/index.tsx